import { render } from "./index.vue?vue&type=template&id=6a987b40&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=6a987b40&lang=scss&scoped=true"

import exportComponent from "/Users/chanjack/Desktop/历史/iot-app-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a987b40"]])

export default __exports__